export default "__VITE_ASSET__Bms$LJ03__"